import React from 'react'

import { Icon, Tooltip } from '@fourthwall/components'
import { QuestionMarkIcon } from '@fourthwall/icons'

import * as S from './SummaryRowLabel.styled'

export type SummaryRowLabelProps = {
  title: string
  tooltip?: string
}

export const SummaryRowLabel = ({ title, tooltip }: SummaryRowLabelProps) => {
  return (
    <S.Container>
      {title}
      {tooltip && (
        <S.TooltipContainer>
          <Tooltip reference={<Icon component={QuestionMarkIcon} height={16} />}>{tooltip}</Tooltip>
        </S.TooltipContainer>
      )}
    </S.Container>
  )
}
